import React, { Component } from "react";
import { Buffer } from "buffer";
import moment from "moment";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import currencyFormat from "../../helper/currencyFormat";
import { Tooltip, Button, Col, Divider, Modal, Row, Table, Tag, message, Form, Select } from "antd";
import { stockOtodisService } from "../../services/otodisApi/StockOtodisService";
import { CopyOutlined } from "@ant-design/icons";
import { ListActiveStates } from "./types/ListActiveStockTypes";
import withAuth from "../../hoc/withAuth";
import Cookies from "universal-cookie";

export interface HomeProps {}

class ListActiveStock extends Component<HomeProps & any, ListActiveStates> {
  private readonly initState!: ListActiveStates;
  private tableColumn: any = [
    {
      title: "Kode Stock Unit",
      dataIndex: "stock_unit_code",
      width: 220,
      render: (value: string, row: any) => {
        return (
          <React.Fragment>
            <span className={`font-90-link`} onClick={(event) => this.showDetail(row)}>
              {value}
            </span>
            &nbsp; &nbsp;
            <Tooltip title="Click untuk copy kode stock unit" color={"cyan"}>
              <CopyOutlined className={"small-avatar-link"} onClick={(event) => this.copyToClipboard(value)} />
            </Tooltip>
            <div style={row?.notes ? {} : { display: "none" }}>
              <i style={{ fontSize: "80%" }}>{row?.notes}</i>
            </div>
          </React.Fragment>
        );
      },
    },
    {
      title: "Kondisi",
      dataIndex: "stock_condition",
      width: 50,
      render: (value: string) => {
        return value === "SECOND" ? <Tag color="error">Bekas</Tag> : <Tag color="success">Baru</Tag>;
      },
    },
    {
      title: "Kendaraan",
      dataIndex: "vehicle_variant_name",
      width: 150,
      render: (value: string, row: any) => {
        return <span className={`font-90`}>{`[${row?.vehicle_year}] ${row?.vehicle_brand_name} - ${row?.vehicle_variant_name}`}</span>;
      },
    },
    {
      title: "Kode Variant",
      dataIndex: "vehicle_variant_code",
      width: 141,
      render: (value: number, row: any) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Warna",
      dataIndex: "vehicle_color_code",
      width: 100,
      render: (value: number, row: any) => {
        return (
          <span className={`font-90`}>
            {value} - {row.vehicle_color_name}
          </span>
        );
      },
    },
    {
      title: "Nomor VIN",
      dataIndex: "vehicle_vin_number",
      width: 50,
    },
    {
      title: "Nomor Mesin",
      dataIndex: "vehicle_engine_number",
      width: 100,
      render: (value: string, row: any) => {
        const showInNosin = row?.stock_condition === "SECOND" ? row?.vehicle_license_plate + " - " + row?.vehicle_engine_number : row?.vehicle_engine_number;
        return <span className={`font-90`}>{`${showInNosin}`}</span>;
      },
    },
    {
      title: "Gudang",
      dataIndex: "warehouse_name",
      width: 141,
      render: (value: number, row: any) => {
        return <span className={`font-90`}>{value}</span>;
      },
    },
    {
      title: "Usia Stock",
      dataIndex: "stock_age_day",
      width: 50,
      sorter: {
        compare: (a: any, b: any) => a.stock_age_day - b.stock_age_day,
      },
    },
  ];
  private uDealer = JSON.parse(Buffer.from(new Cookies().get("_d"), "base64").toString());

  constructor(props: (HomeProps & any) | any) {
    super(props);

    const finalDealerCode = props.match.params.dealerCode.replace(/-/g, "#");
    const picked = this.uDealer.find((o: { DealerCode: any }) => o.DealerCode === finalDealerCode);

    this.initState = {
      processing: false,
      processingFetchTableData: false,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      dealerName: picked.DealerName,
      dataStock: [],
      pageSize: 1000,
      showModalDetailStock: false,
      rowDetailStock: [],
      filterStockStatus: "ACTIVE",
      tableSelectedRowKeys: [],
    };
    this.state = { ...this.initState };
  }

  closeModalDetailStock = (data: any) => {
    this.setState({
      showModalDetailStock: false,
    });
  };

  copyToClipboard = async (data: any) => {
    await navigator.clipboard.writeText(data);
    message.info("Kode Berhasil di Copy");
  };

  exportToCSV = () => {
    const tableSelectedRowKeys = this.state.tableSelectedRowKeys;

    if (tableSelectedRowKeys?.length < 1) {
      message.error("Pilih row yang ingin di export");
      return;
    }
    // Definisikan kolom yang mau diekspor
    const headers = ["Kode Stock", "Kondisi", "Kode Variant", "Nama Variant", "Warna", "Nomor VIN", "Nomor Mesin", "Gudang", "Status Stock", "Usia Stock (hari)"];

    const rows = tableSelectedRowKeys.map((item: any) => [
      item.stock_unit_code,
      item.stock_condition === "SECOND" ? "Bekas" : "Baru",
      item.vehicle_variant_code,
      item.vehicle_variant_name,
      `${item.vehicle_color_code} - ${item.vehicle_color_name}`,
      item.vehicle_vin_number,
      item.vehicle_engine_number,
      item.warehouse_name,
      item.stock_status,
      item.stock_age_day?.toString() || "",
    ]);

    // const csvContent = [headers, ...rows].map((e) => e.map((val: any) => `"${(val ?? "").toString().replace(/"/g, '""')}"`).join(",")).join("\n");
    const csvContent = ["sep=,"].concat([headers, ...rows].map((e) => e.map((val: any) => `"${(val ?? "").toString().replace(/"/g, '""')}"`).join(","))).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Stock_List.csv";
    link.click();
  };

  copyResumeToClipboard = async (data: any) => {
    const resume: any = {};
    for (const item of this.state.dataStock) {
      const tempString = `[${item.vehicle_year}] ${item.vehicle_variant_name} ${item.vehicle_color_code}`;
      if (!resume[tempString]) {
        resume[tempString] = 1;
      } else {
        resume[tempString] += 1;
      }
    }
    let stringResume: string = " " + this.state.dealerName + " [" + moment().format("YYYY-MM-DD HH:mm") + "] \n\n";
    for (const item in resume) {
      stringResume += item + " : " + resume[item]?.toString() + "\n";
    }
    await navigator.clipboard.writeText(stringResume);
    message.info("Resume Berhasil di Copy");
  };

  showDetail = async (data: any) => {
    console.log(data);
    await this.promisedSetState({
      rowDetailStock: data,
      showModalDetailStock: true,
    });
  };

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      processingFetchTableData: true,
      dealerCode: data.value,
    });

    await this.fetchStockData();
  };

  fetchStockData = async () => {
    await this.promisedSetState({
      processingFetchTableData: true,
    });

    await stockOtodisService
      .getStock({
        dealerCode: this.state.dealerCode,
        statusStock: this.state.filterStockStatus,
      })
      .then(async (value) => {
        await this.promisedSetState({
          dataStock: value.data.data,
          processingFetchTableData: false,
        });
      })
      .catch(async (reason) => {
        await this.promisedSetState({
          dataStock: [],
          processingFetchTableData: false,
        });
        message.error("Data Tidak Ditemukan");
      });
  };

  onChangeTable = (pagination: any, filters: any, sorter: any) => {
    console.log(pagination);
    console.log(filters);
    console.log(sorter);
    if (pagination?.pageSize) {
      this.setState({
        pageSize: pagination?.pageSize,
      });
    }
  };

  onFieldChange = async <T extends keyof Pick<any, "filterStockStatus">>(target: T, value: any) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "filterStockStatus":
        currentState.filterStockStatus = value;
        break;
    }
    await this.promisedSetState({
      ...currentState,
    });

    // await this.fetchStockData();
  };

  async componentDidMount() {
    // await this.fetchStockData();
  }

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    const rowTableSelection = {
      onChange: (selectedRowKeys: any, selectedRows: any) => {
        this.setState({
          tableSelectedRowKeys: selectedRows,
        });
      },
    };
    return (
      <React.Fragment>
        <MainLayout
          noPadNoMar={true}
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Stock`}
          breadcrumbMenu={`List Active Stock`}
          defaultSelectedKeys={["m-stock"]}
          defaultOpenKeys={["sm-stock", "sm-sm-stock"]}
        >
          <div style={{ padding: 20 }}>
            <Form layout={`inline`}>
              <Form.Item className={"padTop-10"} style={{ width: 170 }}>
                <i className={`small-text-grey`}>Status</i>
                <Select showSearch placeholder="Pilih Status" optionFilterProp="children" onChange={(value) => this.onFieldChange("filterStockStatus", value)} value={this.state.filterStockStatus}>
                  <Select.Option key={`ACTIVE`} value={`ACTIVE`}>{`ACTIVE`}</Select.Option>
                  <Select.Option key={`DISPLAY`} value={`DISPLAY`}>{`DISPLAY`}</Select.Option>
                  <Select.Option key={`NOTFORSALE`} value={`NOTFORSALE`}>{`NOT FOR SALE`}</Select.Option>
                </Select>
              </Form.Item>
              <Button onClick={this.fetchStockData} style={{ marginTop: 30 }} type={"primary"}>
                {" "}
                Cari{" "}
              </Button>{" "}
              {/* &nbsp;
              <Button onClick={this.copyResumeToClipboard} style={{ marginTop: 30 }} type={"primary"}>
                {" "}
                Salin Ringkasan{" "}
              </Button> */}
              &nbsp;
              <Button onClick={this.exportToCSV} style={{ marginTop: 30 }} type={"primary"}>
                Ekspor ke CSV
              </Button>
            </Form>
          </div>
          <div />
          <Table
            rowSelection={rowTableSelection}
            rowKey={"stock_unit_code"}
            size={"small"}
            scroll={{ x: "calc(500px + 50%)" }}
            loading={this.state.processingFetchTableData}
            columns={this.tableColumn}
            dataSource={this.state.dataStock}
            pagination={{ pageSize: this.state.pageSize }}
            onChange={this.onChangeTable}
          />

          <Modal
            visible={this.state.showModalDetailStock}
            title="Detail Stock"
            onOk={this.closeModalDetailStock}
            onCancel={this.closeModalDetailStock}
            cancelText={"Tutup"}
            okText={false}
            footer={[
              <Button key="back" type="primary" onClick={this.closeModalDetailStock}>
                Tutup
              </Button>,
            ]}
          >
            <Divider orientation="left" plain>
              <span className={`divider-stock-purchase`}>Gudang & Supplier</span>
            </Divider>
            <Row>
              <Col span={8} className={`col-grey`}>
                Kode Stock Unit:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.stock_unit_code}</Col>
              <Col span={8} className={`col-grey`}>
                Tanggal Pembelian:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.stock_delivery_create_date}</Col>
              <Col span={8} className={`col-grey`}>
                Status Stock:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.stock_status}</Col>
              <Col span={8} className={`col-grey`}>
                Kondisi:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.stock_condition}</Col>
              <Col span={8} className={`col-grey`}>
                Supplier:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.supplier_name}</Col>
              <Col span={8} className={`col-grey`}>
                Nomor Order Pembelian:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.stock_delivery_order_number}</Col>
              <Col span={8} className={`col-grey`}>
                Nota Pembayaran:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.stock_debit_note_number}</Col>
              <Col span={8} className={`col-grey`}>
                Gudang:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.warehouse_name}</Col>
            </Row>

            <Divider orientation="left" plain>
              <span className={`divider-stock-purchase`}>Kendaraan</span>
            </Divider>
            <Row>
              <Col span={8} className={`col-grey`}>
                Nomor Polisi:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.vehicle_license_plate}</Col>
              <Col span={8} className={`col-grey`}>
                Merk Kendaraan:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.vehicle_brand_name}</Col>
              <Col span={8} className={`col-grey`}>
                Model Kendaraan:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.vehicle_model_name}</Col>
              <Col span={8} className={`col-grey`}>
                Variant Kendaraan:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.vehicle_variant_name}</Col>
              <Col span={8} className={`col-grey`}>
                Tahun Kendaraan:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.vehicle_year}</Col>
              <Col span={8} className={`col-grey`}>
                Nomor Rangka:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.vehicle_chassis_number}</Col>
              <Col span={8} className={`col-grey`}>
                Nomor Mesin:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.vehicle_engine_number}</Col>
              <Col span={8} className={`col-grey`}>
                Kode Warna:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.vehicle_color_code}</Col>
              <Col span={8} className={`col-grey`}>
                Nama Warna:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.vehicle_color_name}</Col>
            </Row>

            <Divider orientation="left" plain>
              <span className={`divider-stock-purchase`}>Harga Kendaraan</span>
            </Divider>
            <Row>
              <Col span={8} className={`col-grey`}>
                Harga Pembelian:
              </Col>
              <Col span={16}>{currencyFormat(this.state.rowDetailStock?.vehicle_purchase_price)}</Col>
              <Col span={8} className={`col-grey`}>
                Discount:
              </Col>
              <Col span={16}>{currencyFormat(this.state.rowDetailStock?.vehicle_purchase_discount)}</Col>
              <Col span={8} className={`col-grey`}>
                Harga Setelah Diskon:
              </Col>
              <Col span={16}>{currencyFormat(this.state.rowDetailStock?.vehicle_basic_purchase_price)}</Col>
              <Col span={8} className={`col-grey`}>
                VAT:
              </Col>
              <Col span={16}>{currencyFormat(this.state.rowDetailStock?.vehicle_purchase_vat)}</Col>
              <Col span={8} className={`col-grey`}>
                Harga Final:
              </Col>
              <Col span={16}>{currencyFormat(this.state.rowDetailStock?.vehicle_fixed_purchase_price)}</Col>
              <Col span={8} className={`col-grey`}>
                Harga Estimasi Penjualan:
              </Col>
              <Col span={16}>{currencyFormat(this.state.rowDetailStock?.vehicle_sales_price)}</Col>
              <Col span={8} className={`col-grey`}>
                Catatan:
              </Col>
              <Col span={16}>{this.state.rowDetailStock?.notes}</Col>
            </Row>
          </Modal>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(ListActiveStock), 3);
